// extracted by mini-css-extract-plugin
export default {"fieldset":"styles_fieldset__E1tat","small":"styles_small__0hM1l","large":"styles_large__HD4ax"};